import React from 'react'
import cx from "classnames";
import { useEffect, useRef, useState } from "react";
import { TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import { isAgent, isMultiAgentEnabled } from "../../../../../util/helpers";
import { TextWrap } from "../../../../../util/showmore";
import { countries as AllCountries } from "../../data";
import {
  getCountryCodes,
  isCountryLabelMatch,
  isCustomLabelObject,
} from "../../utils";
import stylesNarrow from "./OpcSelect-narrow.module.scss";
import styles from "./OpcSelect.module.scss";

const useStyles = makeStyles({
  root: {
    displaydd: "flex",
    alignItemsdd: "center",
    width: "90%",
    height: 43,
    backgroundColor2: "#f3f6f9",
    borderRadius: "4px",
    border: "solid 1px #ccd6e3",
    backgroundColor: "#f3f6f9",
    color: "#9d9db1",
    marginTop: "8px",
    marginBottom: "8px",
  },
  input: {
    marginLeft: 4,
    flex: 1,
    lineHeight: "2em",
    minWidth: "80%",
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
});

const useStylesInput = makeStyles({
  root: {
    color: "#9d9db1",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#f3f6f9",

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover2": {
      backgroundColor: "#f3f6f9",
    },
    "&$focused": {
      backgroundColor: "#f3f6f9",
    },

    "& .MuiOutlinedInput-input": {
      padding: "18.5px 0px",
      width: 0,
    },
    "& .MuiOutlinedInput-root": {
      paddingLeft: "9px",
      paddingRight: "9px",
      backgroundColor: "#f3f6f9",
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#9d9db1",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
  },

  rootFilled: {
    color: "#1f4a94",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
    },
    "& .MuiOutlinedInput-input": {
      padding: "18.5px 0px",
      width: 0,
    },

    "& .MuiInputBase-root": {
      paddingLeft: "9px",
      paddingRight: "9px",

      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#1f4a94",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
  },

  rootEror: {
    color: "#ff0707",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
    },

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "16px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#ff0707",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#ff0707",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "14px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
  },

  rootNarrow: {
    color: "#9d9db1",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#f3f6f9",
    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover2": {
      backgroundColor: "#f3f6f9",
    },
    "&$focused": {
      backgroundColor: "#f3f6f9",
    },

    "& .MuiOutlinedInput-input": {
      padding: "7.5px 0px",
      width: 0,
    },
    "& .MuiOutlinedInput-root": {
      paddingLeft: "9px",
      paddingRight: "9px",
      backgroundColor: "#f3f6f9",
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#9d9db1",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "500",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
  },

  rootFilledNarrow: {
    color: "#1f4a94",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
    },
    "& .MuiInputBase-root": {
      paddingLeft: "9px",
      paddingRight: "9px",

      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#1f4a94",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 0px",
      width: 0,
    },
  },

  rootErorNarrow: {
    color: "#ff0707",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
    },

    "& .MuiInputBase-root": {
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#ff0707",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#ff0707",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(17px, -7px) scale(0.82)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: "400",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "normal",
      letterSpacing: "normal",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 0px",
      width: 0,
    },
  },
  focused: {},
});

const defaultPlaceholder = "Select";
const defaultSearchPlaceholder = "Search";

const OpcSelect = ({
  type,
  className,
  selected,
  onSelect,
  selectButtonClassName,
  componentType = null,
  showSelectedLabel = true,
  showSecondarySelectedLabel = true,
  showOptionLabel = true,
  showSecondaryOptionLabel = true,
  readOnly = false,
  selectedSize = 16,
  optionsSize = 16,
  customLabels = {},
  placeholder,
  searchable = false,
  searchPlaceholder,
  alignOptionsToRight = false,
  countries,
  blacklistCountries = false,
  fullWidth = true,
  disabled = false,
  id,
  placeholderIcon = false,
  optionItemIcon = false,
  isMobile = false,
  customPadding = null,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [countriesOptions, setCountriesOptions] = useState([]);

  const handleDropdownOpen = (s) => {
    setIsDropdownOpen(s);
  };
  const [filteredCountriesOptions, setFilteredCountriesOptions] = useState([]);
  const [filterValue, setFilterValue] = useState("");

  const selectedFlagRef = useRef(null);
  const optionsRef = useRef(null);
  const filterTextRef = useRef(null);

  const validSelectedValue = countriesOptions.includes(selected)
    ? selected
    : "";

  const options = filterValue ? filteredCountriesOptions : countriesOptions;

  const getSelectedIcon = () => {
    if (customLabels[validSelectedValue]) {
      const icon = customLabels[validSelectedValue]["icon"];
      if (icon) return icon;
    }
    if (optionItemIcon) {
      return optionItemIcon;
    }
    if (placeholderIcon) {
      return placeholderIcon;
    }
  };

  const getLabel = (optionCode) => {
    return customLabels[optionCode] || AllCountries[optionCode];
  };

  const toggleDropdown = () => {
    handleDropdownOpen(!isDropdownOpen);
  };

  const onOptionSelect = (optionCode) => {
    setFilterValue("");
    onSelect(optionCode);
  };

  const filterSearch = (e) => {
    const value = e.target.value || "";
    setFilterValue(value);

    if (!value) {
      setFilteredCountriesOptions([]);
      return;
    }

    const filteredCountriesOptions = countriesOptions.filter((key) => {
      const label = getLabel(key);
      if (isCustomLabelObject(label)) {
        return (
          isCountryLabelMatch(label?.primary, value) ||
          isCountryLabelMatch(label?.secondary, value)
        );
      }
      return isCountryLabelMatch(label, value);
    });

    setFilteredCountriesOptions(filteredCountriesOptions);
  };

  const closeDropdown = (e) => {
    if (selectedFlagRef.current && selectedFlagRef.current.contains(e.target)) {
      return;
    }
    if (
      e.target !== selectedFlagRef.current &&
      e.target !== optionsRef.current &&
      e.target !== filterTextRef.current
    ) {
      handleDropdownOpen(false);
    }
  };

  const closeDropdwownWithKeyboard = (e) => {
    e.preventDefault();
    if (e.keyCode === 27) {
      handleDropdownOpen(false);
    }
  };

  const onSelectWithKeyboard = (e, optionCode) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      onOptionSelect(optionCode);
      handleDropdownOpen(false);
    } else if (e.keyCode === 27) {
      handleDropdownOpen(false);
    }
  };

  useEffect(() => {
    setCountriesOptions(getCountryCodes(countries, blacklistCountries));
  }, [countries, blacklistCountries]);

  useEffect(() => {
    window.addEventListener("click", closeDropdown);

    return () => {
      window.removeEventListener("click", closeDropdown);
    };
  }, []);

  const displayLabel = getLabel(validSelectedValue);

  const lg = useStyles();
  const searchClasses = lg;
  const classes = useStylesInput();

  const selectText = (e) => {
    if (!e || !e.target || !e.target.value) return;
    const len = e.target.value.length;
    e.target.setSelectionRange(0, len);
  };

  const rfs = `rfs-btn-${type}`;

  return (
    <div>
      <div
        className={cx(styles.flagsSelect, className, {
          [styles.flagsSelectInline]: !fullWidth,
        })}
        id={id}
        data-testid="rfs"
      >
        <TextField
          onDoubleClick={selectText}
          onKeyUp2={(e) => closeDropdwownWithKeyboard(e)}
          value={""}
          label={validSelectedValue ? placeholder : null}
          label2={placeholder || defaultPlaceholder}
          outlined={true}
          variant={validSelectedValue ? "outlined" : "outlined"}
          fullWidth
          autoFocus={false}
          className={
            validSelectedValue && !readOnly
              ? componentType === "narrow"
                ? classes.rootFilledNarrow
                : classes.rootFilled
              : componentType === "narrow"
              ? classes.rootNarrow
              : classes.root
          }
          InputProps={{
            onDoubleClick: selectText,
            disableUnderline: true,
            readOnly: readOnly,
            startAdornment: (
              <button
                ref={selectedFlagRef}
                id={rfs}
                type="button"
                className={cx(
                  styles.selectBtn,
                  selectButtonClassName,
                  validSelectedValue && !readOnly
                    ? "ticker-input-filled2 contra-btn"
                    : "ticker-input2 contra-btn",
                  {
                    [styles.disabledBtn]: disabled,
                  }
                )}
                style={{
                  fontSize:
                    type === "dispositions" ||
                    type === "sub_dispositions" ||
                    type === "lead"
                      ? 13
                      : selectedSize,
                  padding: customPadding ? customPadding : "10px",
                }}
                onClick={() => {
                  if (
                    type === "agent_number" &&
                    isAgent() &&
                    isMultiAgentEnabled()
                  ) {
                    return;
                  }
                  toggleDropdown();
                }}
                onKeyUp2={(e) => closeDropdwownWithKeyboard(e)}
                disabled={disabled}
                aria-labelledby={rfs}
                aria-haspopup="listbox"
                aria-expanded={isDropdownOpen}
                data-testid={rfs}
              >
                {validSelectedValue ? (
                  <span
                    aria-labelledby={rfs}
                    style={
                      type === "agent_number"
                        ? {
                            display: "flex",
                            width: "92%",
                            justifyContent: "space-between",
                          }
                        : { display: "flex" }
                    }
                    onClick2={() => {}}
                  >
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className={styles.selectFlag}
                        data-testid="rfs-selected-flag"
                      >
                        {getSelectedIcon()}
                      </span>
                      {showSelectedLabel && (
                        <span className={styles.label}>
                          {isCustomLabelObject(displayLabel) ? (
                            displayLabel.selectedPrimary ? (
                              <TextWrap
                                text={displayLabel.selectedPrimary}
                                max={
                                  type === "dispositions" ||
                                  type === "sub_dispositions"
                                    ? isMobile
                                      ? "20"
                                      : "12"
                                    : "10"
                                }
                              />
                            ) : (
                              <TextWrap
                                text={displayLabel?.primary}
                                max={
                                  type === "dispositions" ||
                                  type === "sub_dispositions"
                                    ? isMobile
                                      ? "20"
                                      : "12"
                                    : "25"
                                }
                              />
                            )
                          ) : (
                            displayLabel
                          )}
                        </span>
                      )}
                    </span>
                    {showSecondarySelectedLabel &&
                      isCustomLabelObject(displayLabel) && (
                        <span className={styles.secondaryLabel}>
                          {displayLabel.selectedSecondary ? (
                            <TextWrap
                              text={displayLabel.selectedSecondary}
                              max="14"
                            />
                          ) : (
                            <TextWrap
                              text={displayLabel?.secondary}
                              max={
                                type === "dispositions" ||
                                type === "sub_dispositions"
                                  ? isMobile
                                    ? "20"
                                    : "12"
                                  : "25"
                              }
                            />
                          )}
                        </span>
                      )}
                  </span>
                ) : (
                  <>
                    <span style={{ display: "flex" }}>
                      <span
                        className={styles.selectFlag}
                        data-testid="rfs-selected-flag"
                      >
                        {placeholderIcon}
                      </span>
                      {showSelectedLabel && (
                        <span className={styles.label}>
                          {placeholder || defaultPlaceholder}
                        </span>
                      )}
                    </span>
                  </>
                )}
              </button>
            ),
          }}
          color="primary"
          autoComplete="off"
          name={"customer_number"}
        ></TextField>

        {!readOnly && !disabled && isDropdownOpen && (
          <ul
            tabIndex={-1}
            role="listbox"
            ref={optionsRef}
            style={{ fontSize: optionsSize }}
            className={cx(
              componentType === "narrow"
                ? stylesNarrow.selectOptions
                : type === "dispositions" || type === "sub_dispositions"
                ? styles.crmFormsSelectOptions
                : styles.selectOptions,
              {
                [styles.selectOptionsWithSearch]: searchable,
                [styles.alignOptionsToRight]: alignOptionsToRight,
                [styles.fullWidthOptions]: fullWidth,
              }
            )}
          >
            {searchable && (
              <div
                className={styles.filterBox2}
                style={{
                  display: "flex",
                  marginTop: "9px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Paper className={searchClasses.root} elevation={0}>
                  <IconButton
                    className={searchClasses.iconButton}
                    aria-label={searchPlaceholder || defaultSearchPlaceholder}
                  >
                    <SearchIcon />
                  </IconButton>
                  <InputBase
                    inputRef={filterTextRef}
                    className={searchClasses.input}
                    placeholder={searchPlaceholder || defaultSearchPlaceholder}
                    inputProps={{
                      "aria-label":
                        searchPlaceholder || defaultSearchPlaceholder,
                    }}
                    value={filterValue}
                    onChange={filterSearch}
                  />
                </Paper>
              </div>
            )}
            {options.map((optionCode) => {
              const optionLabel = getLabel(optionCode);
              if(type === "agent_number" && !optionLabel?.data?.is_active) return;
              return (
                <li
                  key={optionCode}
                  id={`rfs-${optionCode}`}
                  role="option"
                  tabIndex={0}
                  className={cx(
                    componentType === "narrow"
                      ? stylesNarrow.selectOption
                      : styles.selectOption,
                    {
                      [styles.selectOptionWithlabel]: showOptionLabel,
                    },
                    "select-option"
                  )}
                  onClick={() => onOptionSelect(optionCode)}
                  onKeyUp={(e) => onSelectWithKeyboard(e, optionCode)}
                >
                  {(type === "agent_number" || type === "callid") && (
                    <div className={"wiget-item"}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {optionLabel.icon && (
                          <span className={"agent-dp-sec"}>
                            {optionLabel.icon}
                          </span>
                        )}
                        {showOptionLabel && (
                          <span className={"text-primary"}>
                            {isCustomLabelObject(optionLabel) ? (
                              optionLabel.selectedPrimary ? (
                                <TextWrap
                                  text={displayLabel?.selectedPrimary ?? ""}
                                  max="14"
                                />
                              ) : (
                                optionLabel?.primary
                              )
                            ) : (
                              optionLabel
                            )}
                          </span>
                        )}
                      </div>
                      {showSecondaryOptionLabel &&
                        isCustomLabelObject(optionLabel) && (
                          <span className={"text-secondary"}>
                            {optionLabel.selectedSecondary ? (
                              <TextWrap
                                text={displayLabel?.selectedSecondary ?? ""}
                                max="20"
                              />
                            ) : (
                              optionLabel?.secondary
                            )}
                          </span>
                        )}
                    </div>
                  )}
                  {type === "sr_number" && (
                    <>
                      <div className="srnum-entity">
                        <div className="srnum-primary">
                          {optionLabel?.primary}
                        </div>
                        <div className="srnum-secondary">
                          {optionLabel?.secondary}
                        </div>
                      </div>
                    </>
                  )}

                  {(type === "dispositions" ||
                    type === "sub_dispositions" ||
                    type === "lead") && (
                    <div className={"wiget-item"}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: "13px",
                        }}
                      >
                        {optionLabel.icon && (
                          <span className={"agent-dp-sec"}>
                            {optionLabel.icon}
                          </span>
                        )}
                        {showOptionLabel && (
                          <span className={"text-primary"}>
                            {isCustomLabelObject(optionLabel) ? (
                              <TextWrap
                                text={optionLabel?.primary}
                                max={isMobile ? "20" : "12"}
                              />
                            ) : (
                              optionLabel
                            )}
                          </span>
                        )}
                      </div>
                      {showSecondaryOptionLabel &&
                        isCustomLabelObject(optionLabel) && (
                          <span className={"text-secondary"}>
                            <TextWrap
                              text={optionLabel?.secondary}
                              max={isMobile ? "20" : "12"}
                            />
                          </span>
                        )}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default OpcSelect;
